import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import EmailSignupModal from "./EmailSignupModal";
import prioritiesImage1 from "../images/strengthening-education.png";
import prioritiesImage1b from "../images/strengthening-education.png";
import prioritiesImage1c from "../images/strengthening-education.png";
import prioritiesImage2 from "../images/strengthening-education.png";
import prioritiesImage3 from "../images/strengthening-education.png";
import prioritiesImage4 from "../images/strengthening-education.png";
import targetImage from "../images/prioritiesHeader.jpg";
import {
  AssuredWorkload,
  Engineering,
  LocalAirport,
  LocalPolice,
  School,
  Traffic,
  Home,
  BusinessCenter,
  MonetizationOn,
  Commute,
  LocalHospital,
  Gavel,
  SupportAgent,
} from "@mui/icons-material";
const Priorities = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);
  return (
    <Box sx={{ backgroundColor: "#FFFDF7!important" }}>
      {/* Header */}
      <Box
        sx={{
          backgroundImage: `url(${targetImage})`,
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "left" : "center",
          backgroundPositionY: "-30vh",
          backgroundRepeat: "no-repeat",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
              background: '#1d2845d1',
              borderRadius: "8px",
              padding: "8px 16px",
            },
          }}
        >
          priorities
        </Typography>
      </Box>
      {/* Body */}
      <Box
        p={isMobile ? "0 16px" : "96px 96px 48px"}
        sx={{ background: "#1d2845" }}
        className="priorities-page-wrap"
      >
        <Grid container alignItems="flex-start">
          {/* Education */}
          <Grid container className="section-wrap" mt={0} mb={isMobile ? 2 : 0}>
            <Grid
              item
              xs={12}
              md={3}
              my={isMobile ? 2 : 0}
              display={isMobile ? "none!important" : "flex"}
              justifyContent={"center"}
            >
              <School
                sx={{
                  fontSize: "8rem",
                  fill: "white",
                  border: "1px solid white",
                  borderRadius: "8px",
                  p: 1,
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={7.5}
              sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
            >
              <Typography
                variant="h3"
                sx={{ mb: 2, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}
              >
                Education
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                Jeremiah has been a longtime advocate for improving education for every child in our county. He has served on the NAACP Parents’ Council and testified in support of fully funding our public schools (including the Linkage to Learning program at Burtonsville Elementary). He has stood up for our teachers and organized forums to advocate for schools in East County.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, fontSize: "1.25rem", color: "white!important" }}>
                On the County Council, he will fight to make sure that all our schools receive the resources they need to give every student the best possible education regardless of where they live.
              </Typography>
            </Grid>
            <Grid item xs={false} sx={{ display: isMobile ? "none" : "initial" }}></Grid>
          </Grid>

          {/* Housing */}
          <Grid container className="section-wrap" my={isMobile ? 2 : 12} sx={{ background: isMobile ? "none" : "#00853e", borderRadius: ".5rem" }}>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "1" }}></Grid>
            <Grid item xs={12} md={7.5} mt={isMobile ? 2 : 2} sx={{ order: isMobile ? "3" : "1", display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
              <Typography variant="h3" sx={{ mb: 3, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Housing
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                Jeremiah finds it unacceptable that middle class and working families are spending more than 30% of their income to provide a roof over their heads. It is too expensive to live in Montgomery County. The affordable housing crisis can be resolved through progressive rezoning policies that increase the amount of affordable housing in the county and require new residential construction to include affordable units.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, fontSize: "1.25rem", color: "white!important" }}>
                He will fight to protect renters, support safe and clean housing, expand first-time home buyer credits, and convert commercial space into more housing while preserving neighborhood character.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, fontSize: "1.1rem", color: "white!important" }}>
                Photo: <a href="https://drive.google.com/drive/u/1/folders/10xuiivWvVvexgxDUdBVS9Wg4UW2ZR86W" target="_blank" rel="noopener noreferrer" style={{ color: "#FFF" }}>Housing images</a>
              </Typography>
              <Typography variant="body1" sx={{ mt: 1, fontSize: "1.1rem", color: "white!important" }}>
                Video testimony: <a href="https://www.youtube.com/watch?v=0MtVWopCQ9o" target="_blank" rel="noopener noreferrer" style={{ color: "#FFF" }}>Watch testimony</a>
              </Typography>
            </Grid>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "2" }}></Grid>
            <Grid item display={isMobile ? "none!important" : "flex"} justifyContent={"center"} flexDirection="column" alignItems="flex-end" xs={12} md={3} sx={{ order: isMobile ? "1" : "3", padding: isMobile ? "0" : "1rem", maxHeight: "fit-content" }}>
              <Home sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
          </Grid>

          {/* Jobs & Economy */}
          <Grid container className="section-wrap" mb={3} display={"flex"}>
            <Grid item xs={12} md={3} my={isMobile ? 2 : 0} display={isMobile ? "none!important" : "flex"} justifyContent={"center"}>
              <BusinessCenter sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
            <Grid item xs={12} md={7.5} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <Typography variant="h3" sx={{ mb: 2, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Jobs and Economy
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                As a small business owner himself, Jeremiah understands how to create jobs. He’ll work with small and minority-owned businesses to provide tax incentives that help them grow. He will support investments to grow our local economy, expand our tax base, and create jobs while opposing ill-timed property tax increases.
              </Typography>
              <Typography variant="body1" sx={{ mt: 1, fontSize: "1.1rem", color: "white!important" }}>
                Testimony: <a href="https://www.youtube.com/watch?v=7hpE2YeTt2I" target="_blank" rel="noopener noreferrer" style={{ color: "#FFF" }}>Watch testimony</a>
              </Typography>
            </Grid>
            <Grid item xs={false} sx={{ display: isMobile ? "none" : "initial" }}></Grid>
          </Grid>

          {/* Public Safety */}
          <Grid container className="section-wrap" my={isMobile ? 2 : 12} sx={{ background: isMobile ? "none" : "#00853e", borderRadius: ".5rem" }}>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "1" }}></Grid>
            <Grid item xs={12} md={7.5} mt={isMobile ? 2 : 2} sx={{ order: isMobile ? "3" : "1", display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
              <Typography variant="h3" sx={{ mb: 3, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Public Safety
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                Jeremiah has consistently worked to make everyone in our communities safer. He fought to strengthen hate crimes laws, helped protect women from domestic violence by removing a spousal defense in cases of sexual violence, and worked on legislation to reform marijuana laws so police can focus on serious crimes.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, fontSize: "1.1rem", color: "white!important" }}>
                Media: Standing Up For Our Small Businesses Against Crime<a href="https://www.youtube.com/watch?v=k3uu6qDB2VE" target="_blank" rel="noopener noreferrer" style={{ color: "#FFF" }}>Watch</a>
              </Typography>
            </Grid>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "2" }}></Grid>
            <Grid item display={isMobile ? "none!important" : "flex"} flexDirection="column" alignItems="flex-end" xs={12} md={3} sx={{ order: isMobile ? "1" : "3", padding: isMobile ? "0" : "1rem", maxHeight: "fit-content" }}>
              <LocalPolice sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
          </Grid>

          {/* Transportation */}
          <Grid container className="section-wrap" mb={3}>
            <Grid item xs={12} md={3} my={isMobile ? 2 : 0} display={isMobile ? "none!important" : "flex"}>
              <Commute sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
            <Grid item xs={12} md={7.5} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <Typography variant="h3" sx={{ mb: 2, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Transportation
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                Jeremiah supports expanding and improving regional transit infrastructure — including Bus Rapid Transit (BRT), the Purple Line, Burtonsville Access Road, and the Mid-County Corridor study — to reduce traffic, lower emissions, and improve connectivity.
              </Typography>
            </Grid>
            <Grid item xs={false} sx={{ display: isMobile ? "none" : "initial" }}></Grid>
          </Grid>

          {/* Health Care */}
          <Grid container className="section-wrap" my={isMobile ? 2 : 12} sx={{ background: isMobile ? "none" : "#00853e", borderRadius: ".5rem" }}>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "1" }}></Grid>
            <Grid item xs={12} md={7.5} mt={isMobile ? 2 : 2} sx={{ order: isMobile ? "3" : "1", display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
              <Typography variant="h3" sx={{ mb: 3, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Health Care
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                Jeremiah believes it is wrong that so many families remain uninsured or underinsured or are forced into massive medical debt. He will fight to ensure everyone, especially the most vulnerable, have access to quality, affordable health care and support programs that expand access locally.
              </Typography>
            </Grid>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "2" }}></Grid>
            <Grid item display={isMobile ? "none!important" : "flex"} flexDirection="column" alignItems="flex-end" xs={12} md={3} sx={{ order: isMobile ? "1" : "3", padding: isMobile ? "0" : "1rem", maxHeight: "fit-content" }}>
              <LocalHospital sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
          </Grid>

          {/* Standing up for Government Workers */}
          <Grid container className="section-wrap" mb={3}>
            <Grid item xs={12} md={3} my={isMobile ? 2 : 0} display={isMobile ? "none!important" : "flex"} justifyContent={"center"}>
              <Gavel sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
            <Grid item xs={12} md={7.5} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <Typography variant="h3" sx={{ mb: 2, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Standing up for Government Workers
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                Jeremiah is standing up for our government workers and defending democratic institutions. He has participated in rallies and actions to support workers and will work to provide support for those who have lost jobs while protecting the integrity of our elections. (Union endorsement)
              </Typography>
            </Grid>
            <Grid item xs={false} sx={{ display: isMobile ? "none" : "initial" }}></Grid>
          </Grid>

          {/* Constituent Service */}
          <Grid container className="section-wrap" my={isMobile ? 2 : 12} sx={{ background: isMobile ? "none" : "#00853e", borderRadius: ".5rem" }}>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "1" }}></Grid>
            <Grid item xs={12} md={7.5} mt={isMobile ? 2 : 2} sx={{ order: isMobile ? "3" : "1", display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
              <Typography variant="h3" sx={{ mb: 3, color: "#FFFDF7!important", fontSize: isMobile ? "1.5rem!important" : "2rem!important" }}>
                Constituent Service
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.25rem", color: "white!important" }}>
                As Chief of Staff to the Deputy Majority Whip Charlotte Crutchfield, Jeremiah has provided constituent services helping residents with everything from potholes to complex casework. On the County Council, he will make constituent services a priority so every resident gets the help they need.
              </Typography>
            </Grid>
            <Grid item xs={false} my={18} sx={{ display: isMobile ? "none" : "initial", order: "2" }}></Grid>
            <Grid item display={isMobile ? "none!important" : "flex"} flexDirection="column" alignItems="flex-end" xs={12} md={3} sx={{ order: isMobile ? "1" : "3", padding: isMobile ? "0" : "1rem", maxHeight: "fit-content" }}>
              <SupportAgent sx={{ fontSize: "8rem", fill: "white", border: "1px solid white", borderRadius: "8px", p: 1 }} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          pb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#00853e!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton component="a" href="https://instagram.com/popeforcouncil" target="_blank" rel="noopener noreferrer">
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="https://twitter.com/popeforcouncil" target="_blank" rel="noopener noreferrer">
              <TwitterIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="https://facebook.com/popeforcouncil" target="_blank" rel="noopener noreferrer">
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="https://www.youtube.com/@JeremiahPopeForCouncil" target="_blank" rel="noopener noreferrer">
              <YouTubeIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="mailto:info@popeforcouncil">
              <EmailIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By Authority: Pope For Council, Angie Logan-Pope, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};
export default Priorities;
